import { render, staticRenderFns } from "./courseCatalogue.vue?vue&type=template&id=7b11ebe8&scoped=true&"
import script from "./courseCatalogue.vue?vue&type=script&lang=js&"
export * from "./courseCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./courseCatalogue.vue?vue&type=style&index=0&lang=less&"
import style1 from "./courseCatalogue.vue?vue&type=style&index=1&id=7b11ebe8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b11ebe8",
  null
  
)

export default component.exports